module.exports = __webpack_public_path__ + "static/winner2-6c86eb8eebe9ca8978fdb8b5163a6fb7.png";